<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-md-2 "></div>
            <div class="col-md-10 ">
                <div class="header-block">
                    <h2>Anima Benefits</h2>
                    <p>
                        Experience unparalleled care with Anima, founded on four essential pillars: the rigor of
                        scientific research, cutting-edge eye-tracking technology, uncompromising privacy standards, and
                        objective analysis.
                    </p>
                </div>
            </div>
        </div>

        <app-about-us-item [item]="item" *ngFor="let item of items"></app-about-us-item>

        <!--        <app-achivement></app-achivement>-->

    </div>
</section>
